// extracted by mini-css-extract-plugin
export var chip = "_64-9";
export var chipLabel = "_64-a";
export var close = "_64-7";
export var closeIcon = "_64-8";
export var error = "_64-6";
export var infoTooltip = "_64-2";
export var innerContainer = "_64-1";
export var input = "_64-b";
export var medium = "_64-5";
export var outerContainer = "_64-0";
export var small = "_64-4";
export var xSmall = "_64-3";